import React from 'react';

interface Props {
    when?: boolean;
}

export default class BeforeUnload extends React.Component<Props> {
    componentDidMount(): void {
        window.addEventListener('beforeunload', this.handleBeforeunload);
    }

    componentWillUnmount(): void {
        window.removeEventListener('beforeunload', this.handleBeforeunload);
    }

    handleBeforeunload = (event: BeforeUnloadEvent): any => {
        const { when } = this.props;

        if (when) {
            event.preventDefault();
            // eslint-disable-next-line
            event.returnValue = ''; // Chrome requires returnValue to be set
            return '';
        }
        return undefined;
    };

    render(): null {
        return null;
    }
}
